import FirstSettingsForm from './FirstSettingsForm'

export default FirstSettingsForm
